module.exports = __webpack_public_path__ + "img/cases-brand-yincheng-3.e68a480c.jpg";